/**
 * Environment configuration for the web app
 * This centralizes access to environment variables and provides defaults
 */

declare global {
  // Define global variable injected during the build
  const __API_URL__: string;
}

interface Environment {
  /**
   * URL of the backend server for all API and WebSocket connections
   */
  API_URL: string;

  /**
   * Current environment (development, staging, production)
   */
  NODE_ENV: string;

  /**
   * Whether the app is running in development mode
   */
  isDevelopment: boolean;

  /**
   * Whether the app is running in production mode
   */
  isProduction: boolean;
}

// The __API_URL__ is a global constant injected by Vite during the build process.
// It's a direct text replacement, so we can access it directly.
const apiUrl = typeof __API_URL__ !== "undefined" ? __API_URL__ : "";
const nodeEnv = process.env.NODE_ENV || "development";

// Create and export the environment object
export const env: Environment = {
  API_URL: apiUrl,
  NODE_ENV: nodeEnv,
  isDevelopment: nodeEnv === "development",
  isProduction: nodeEnv === "production",
};

/**
 * Helper function to get the URL for a specific API endpoint
 */
export function getApiUrl(path: string): string {
  // Remove any leading slash from the path to avoid double slashes
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
  return `${env.API_URL}/${normalizedPath}`;
}
